

/* ================================================================
   GEO PINCODE DETECTOR v2.0
   Kalki Fashion — Guest User Location with Confirmation
   Original APIs (Nominatim + BigDataCloud) - No LocationIQ
   ================================================================ */

(function () {
  'use strict';

  /* ── CONFIG ── */
  const GEO_ASKED_KEY = 'kf_geo_asked';
  const GEO_DELAY_MS  = 1500;

  /* ── HELPERS ── */
  function isGuest() {
    return !window.customerId || window.customerId === '';
  }

  function alreadyAsked() {
    return !!localStorage.getItem(GEO_ASKED_KEY);
  }

  function hasPin() {
    return typeof getFinalPin === 'function' && /^\d{6}$/.test(getFinalPin() || '');
  }

  function isIOS() {
    return /iP(hone|od|ad)/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  /* ── REVERSE GEOCODE: lat/lng → pincode ── */
  async function getPincodeFromCoords(lat, lng) {
    /* Primary: OpenStreetMap Nominatim */
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`;
      const res  = await fetch(url, { headers: { 'Accept-Language': 'en' } });
      const data = await res.json();
      const pin  = data?.address?.postcode?.replace(/[^0-9]/g, '').slice(0, 6);
      if (pin && /^\d{6}$/.test(pin)) {
        console.log('[KF Geo] ✅ Nominatim pincode:', pin);
        return pin;
      }
    } catch (e) {
      console.warn('[KF Geo] Nominatim failed:', e);
    }

    /* Fallback: BigDataCloud */
    try {
      const url2 = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`;
      const res2  = await fetch(url2);
      const data2 = await res2.json();
      const pin2  = (data2?.postcode || '').replace(/[^0-9]/g, '').slice(0, 6);
      if (pin2 && /^\d{6}$/.test(pin2)) {
        console.log('[KF Geo] ⚠️ BigDataCloud pincode (fallback):', pin2);
        return pin2;
      }
    } catch (e) {
      console.warn('[KF Geo] BigDataCloud failed:', e);
    }

    return null;
  }

  /* ── POPUP HTML + CSS ── */
  function injectStyles() {
    if (document.getElementById('kf-geo-styles')) return;
    const style = document.createElement('style');
    style.id = 'kf-geo-styles';
    style.textContent = `
      #kf-geo-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 99998;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: kfGeoFadeIn 0.25s ease;
      }
      @keyframes kfGeoFadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      #kf-geo-popup {
        background: #fff;
        border-radius: 14px;
        padding: 28px 24px 22px;
        width: 320px;
        max-width: calc(100vw - 32px);
        box-shadow: 0 8px 40px rgba(0,0,0,0.18);
        text-align: center;
        position: relative;
        animation: kfGeoSlideUp 0.3s cubic-bezier(.34,1.4,.64,1);
      }
      @keyframes kfGeoSlideUp {
        from { transform: translateY(30px); opacity: 0; }
        to   { transform: translateY(0);    opacity: 1; }
      }
      #kf-geo-popup .kf-geo-icon {
        width: 38px;
        height: 38px;
        margin: 0 auto 10px;
        display: block;
        color: #555;
      }
      #kf-geo-popup .kf-geo-site {
        font-size: 13px;
        color: #888;
        margin-bottom: 4px;
        font-family: inherit;
      }
      #kf-geo-popup .kf-geo-title {
        font-size: 16px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 18px;
        font-family: inherit;
        line-height: 1.35;
      }
      #kf-geo-popup .kf-geo-btn {
        display: block;
        width: 100%;
        padding: 12px 16px;
        border-radius: 8px;
        border: none;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        font-family: inherit;
        letter-spacing: 0.01em;
        transition: background 0.15s, opacity 0.15s;
        margin-bottom: 10px;
      }
      #kf-geo-popup .kf-geo-btn-allow {
        background: #000;
        color: #fff;
      }
      #kf-geo-popup .kf-geo-btn-allow:hover { background: #222; }
      #kf-geo-popup .kf-geo-btn-once {
        background: #000;
        color: #fff;
      }
      #kf-geo-popup .kf-geo-btn-once:hover { background: #222; }
      #kf-geo-popup .kf-geo-btn-deny {
        background: transparent;
        color: #000;
        font-weight: 500;
        margin-bottom: 0;
        border: 1.5px solid #ddd;
      }
      #kf-geo-popup .kf-geo-btn-deny:hover { background: #f5f5f5; }
      #kf-geo-popup .kf-geo-close {
        position: absolute;
        top: 12px;
        right: 14px;
        background: none;
        border: none;
        cursor: pointer;
        color: #999;
        font-size: 20px;
        line-height: 1;
        padding: 0;
      }
      #kf-geo-popup .kf-geo-close:hover { color: #444; }
      #kf-geo-popup.kf-geo-loading .kf-geo-btn-allow,
      #kf-geo-popup.kf-geo-loading .kf-geo-btn-once {
        opacity: 0.6;
        cursor: wait;
        pointer-events: none;
      }
      #kf-geo-spinner {
        display: none;
        width: 18px;
        height: 18px;
        border: 2px solid #ddd;
        border-top-color: #1a6ab1;
        border-radius: 50%;
        animation: kfSpin 0.7s linear infinite;
        margin: 8px auto 0;
      }
      @keyframes kfSpin { to { transform: rotate(360deg); } }
    `;
    document.head.appendChild(style);
  }

  function createPopup() {
    const overlay = document.createElement('div');
    overlay.id = 'kf-geo-overlay';
    overlay.innerHTML = `
      <div id="kf-geo-popup" role="dialog" aria-modal="true" aria-labelledby="kf-geo-title">
        <button class="kf-geo-close" id="kf-geo-close-btn" aria-label="Close">&#x2715;</button>
        <svg class="kf-geo-icon" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          <circle cx="12" cy="9" r="2.5"/>
        </svg>
        <div class="kf-geo-site">kalkifashion.com</div>
        <div class="kf-geo-title" id="kf-geo-title">Know your location</div>
        <button class="kf-geo-btn kf-geo-btn-allow" id="kf-geo-allow-btn">
          Allow while visiting the site
        </button>
        <button class="kf-geo-btn kf-geo-btn-once" id="kf-geo-once-btn">
          Allow this time
        </button>
        <button class="kf-geo-btn kf-geo-btn-deny" id="kf-geo-deny-btn">
          Never allow
        </button>
        <div id="kf-geo-spinner"></div>
      </div>
    `;
    return overlay;
  }

  /* ── REMOVE POPUP ── */
  function removePopup() {
    const el = document.getElementById('kf-geo-overlay');
    if (el) {
      el.style.animation = 'kfGeoFadeIn 0.2s ease reverse';
      setTimeout(() => el.remove(), 200);
    }
  }

  /* ── SET LOADING STATE ── */
  function setLoading(on) {
    const popup   = document.getElementById('kf-geo-popup');
    const spinner = document.getElementById('kf-geo-spinner');
    if (!popup) return;
    popup.classList.toggle('kf-geo-loading', on);
    if (spinner) spinner.style.display = on ? 'block' : 'none';
  }

  /* ── USER CONFIRMATION POPUP ── */
  function showPincodeConfirmation(detectedPin) {
    const popup = document.getElementById('kf-geo-popup');
    if (!popup) return;
    
    popup.innerHTML = `
      <button class="kf-geo-close" id="kf-geo-close-final" aria-label="Close">&#x2715;</button>
      <svg class="kf-geo-icon" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
      <div class="kf-geo-site">Detected Pincode</div>
      <div class="kf-geo-title" style="font-size: 28px; font-weight: 700; margin: 12px 0; letter-spacing: 2px;">${detectedPin}</div>
      <div style="font-size: 13px; color: #666; margin-bottom: 18px;">Is this your correct pincode?</div>
      <button class="kf-geo-btn kf-geo-btn-allow" id="kf-confirm-yes">
        ✓ Yes, this is correct
      </button>
      <button class="kf-geo-btn kf-geo-btn-deny" id="kf-confirm-edit" style="margin-bottom: 10px;">
        ✎ Edit pincode
      </button>
      <button class="kf-geo-btn kf-geo-btn-deny" id="kf-confirm-skip" style="border: none; background: transparent; color: #999; font-size: 13px;">
        Skip for now
      </button>
    `;
    
    // YES - Save detected pincode
    document.getElementById('kf-confirm-yes')?.addEventListener('click', () => {
      localStorage.setItem(GEO_ASKED_KEY, 'allowed');
      if (typeof savePin === 'function') savePin(detectedPin, false);
      triggerPinUpdate(detectedPin);
      removePopup();
      console.log('[KF Geo] ✅ User confirmed pincode:', detectedPin);
    });
    
    // EDIT - Manual entry
    document.getElementById('kf-confirm-edit')?.addEventListener('click', () => {
      showManualPincodeEntry(detectedPin);
    });
    
    // SKIP - Close without saving
    document.getElementById('kf-confirm-skip')?.addEventListener('click', () => {
      localStorage.setItem(GEO_ASKED_KEY, 'denied');
      removePopup();
    });
    
    // Close button
    document.getElementById('kf-geo-close-final')?.addEventListener('click', () => {
      localStorage.setItem(GEO_ASKED_KEY, 'denied');
      removePopup();
    });
  }

  /* ── MANUAL PINCODE ENTRY ── */
  function showManualPincodeEntry(suggestedPin) {
    const popup = document.getElementById('kf-geo-popup');
    if (!popup) return;
    
    popup.innerHTML = `
      <button class="kf-geo-close" id="kf-geo-close-manual" aria-label="Close">&#x2715;</button>
      <svg class="kf-geo-icon" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
      <div class="kf-geo-site">Enter Your Pincode</div>
      <div class="kf-geo-title" style="font-size: 15px; margin-bottom: 14px;">We detected <strong>${suggestedPin}</strong><br>Please verify or correct it</div>
      <input 
        type="tel" 
        id="kf-manual-pin-input" 
        maxlength="6" 
        pattern="[0-9]{6}" 
        placeholder="Enter 6-digit pincode"
        value="${suggestedPin}"
        style="
          width: 100%;
          padding: 12px 16px;
          border: 1.5px solid #ddd;
          border-radius: 8px;
          font-size: 16px;
          text-align: center;
          letter-spacing: 2px;
          font-weight: 600;
          margin-bottom: 12px;
          font-family: inherit;
          box-sizing: border-box;
        "
      />
      <button class="kf-geo-btn kf-geo-btn-allow" id="kf-manual-save">
        Save Pincode
      </button>
      <button class="kf-geo-btn kf-geo-btn-deny" id="kf-manual-cancel" style="border: none; background: transparent; color: #999;">
        Cancel
      </button>
    `;
    
    const input = document.getElementById('kf-manual-pin-input');
    const saveBtn = document.getElementById('kf-manual-save');
    
    // Auto-select text on focus
    input?.focus();
    input?.select();
    
    // Validate input
    input?.addEventListener('input', (e) => {
      const val = e.target.value.replace(/[^0-9]/g, '');
      e.target.value = val;
      
      if (val.length === 6) {
        saveBtn.disabled = false;
        saveBtn.style.opacity = '1';
        saveBtn.style.cursor = 'pointer';
      } else {
        saveBtn.disabled = true;
        saveBtn.style.opacity = '0.5';
        saveBtn.style.cursor = 'not-allowed';
      }
    });
    
    // Save button
    saveBtn?.addEventListener('click', () => {
      const manualPin = input?.value || '';
      if (/^\d{6}$/.test(manualPin)) {
        localStorage.setItem(GEO_ASKED_KEY, 'allowed');
        if (typeof savePin === 'function') savePin(manualPin, true); // isManual = true
        triggerPinUpdate(manualPin);
        removePopup();
        console.log('[KF Geo] ✅ User manually entered pincode:', manualPin);
      }
    });
    
    // Cancel - go back to confirmation
    document.getElementById('kf-manual-cancel')?.addEventListener('click', () => {
      showPincodeConfirmation(suggestedPin);
    });
    
    // Close button
    document.getElementById('kf-geo-close-manual')?.addEventListener('click', () => {
      localStorage.setItem(GEO_ASKED_KEY, 'denied');
      removePopup();
    });
    
    // Enter key to save
    input?.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && input.value.length === 6) {
        saveBtn?.click();
      }
    });
  }

  /* ── HANDLE ALLOW ── */
  async function handleAllow() {
    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        const pin = await getPincodeFromCoords(latitude, longitude);

        setLoading(false);
        
        if (pin) {
          // ✅ Show confirmation popup
          showPincodeConfirmation(pin);
        } else {
          removePopup();
          localStorage.setItem(GEO_ASKED_KEY, 'allowed');
          console.warn('[KF Geo] ⚠️ Pincode nahi mila coordinates se');
        }
      },
      (err) => {
        setLoading(false);
        removePopup();
        localStorage.setItem(GEO_ASKED_KEY, 'denied');

        // Error code 1 = Permission denied
        if (err.code === 1) {
          showLocationGuide();
        }

        console.warn('[KF Geo] Geolocation denied or failed:', err.message);
      },
      { timeout: 10000, maximumAge: 300000 }
    );
  }

  /* ── HANDLE DENY ── */
  function handleDeny() {
    localStorage.setItem(GEO_ASKED_KEY, 'denied');
    removePopup();
  }

  /* ── LOCATION PERMISSION GUIDE (iOS) ── */
  function showLocationGuide() {
    localStorage.removeItem('kf_geo_asked'); // Reload pe retry hoga
    
    injectStyles();

    // Extra styles for guide banner
    const extra = document.createElement('style');
    extra.textContent = `
      #kf-geo-guide {
        position: fixed;
        top:0; left: 0; right: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 -4px 20px rgba(0,0,0,0.12);
        z-index: 99999;
        padding:0;
        animation: kfSlideUpGuide 0.3s ease;
        font-family: inherit;
      }
      .kf-geo-guide-back{
        background-color: #fff;
        height: fit-content;
        padding: 16px 20px 24px;
        position: relative;
        border-radius: 5px;
        margin: 0 16px;
      }
      @keyframes kfSlideUpGuide {
        from { transform: translateY(100%); }
        to   { transform: translateY(0); }
      }
      #kf-geo-guide .kf-guide-title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 8px;
      }
      #kf-geo-guide .kf-guide-steps {
        font-size: 13px;
        color: #555;
        line-height: 1.6;
        margin-bottom: 14px;
      }
      #kf-geo-guide .kf-guide-steps span {
        display: block;
      }
      #kf-geo-guide .kf-guide-close {
        position: absolute;
        top: 5px; right: 5px;
        background: none;
        border: none;
        font-size: 18px;
        color: #999;
        cursor: pointer;
        padding: 0;
      }
      #kf-geo-guide .kf-guide-btn {
        display: block;
        width: 100%;
        padding: 12px;
        background: #000;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        font-family: inherit;
        text-align: center;
      }
    `;
    document.head.appendChild(extra);

    const isChrome = /CriOS/.test(navigator.userAgent);
    const isSafari = /Safari/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent);

    // let steps = '';
    // if (isChrome) {
    //   steps = `
    //     <span>1. Kindly Enable Your Phone Location</span>
    //   `;
    // } else if (isSafari) {
    //   steps = `
    //     <span>1. Kindly Enable Your Phone Location</span>
    //   `;
    // } else {
    //   steps = `
    //     <span>1. Kindly Enable Your Phone Location</span>
    //   `;
    // }

    const guide = document.createElement('div');
    guide.id = 'kf-geo-guide';
    guide.innerHTML = `
      <div class="kf-geo-guide-back">
        <button class="kf-guide-close" id="kf-guide-close">&#x2715;</button>
        <div class="kf-guide-title">📍 Your Location Access is Blocked Kindly Enable</div>
       
        <button class="kf-guide-btn" id="kf-guide-reload">Reload Page</button>
      </div>
    `;
    document.body.appendChild(guide);

    document.getElementById('kf-guide-reload')?.addEventListener('click', () => {
      location.reload();
    });

    document.getElementById('kf-guide-close')?.addEventListener('click', () => {
      guide.remove();
    });
  }

  /* ── TRIGGER UI UPDATE ON CURRENT PAGE ── */
  function triggerPinUpdate(pin) {
    /* 1. Input fields */
    document.querySelectorAll('#pincodeInput').forEach(el => {
      el.value = pin;
      el.dispatchEvent(new Event('input',  { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* 2. Zip spans */
    document.querySelectorAll('.selected-zip span').forEach(el => {
      el.textContent = pin;
    });

    /* 3. Custom event */
    document.dispatchEvent(new CustomEvent('kf:pinUpdated', { detail: { pin } }));

    /* 4. Direct function calls */
    if (typeof getLocationDetails === 'function') {
      getLocationDetails();
      return;
    }

    if (typeof updateDeliveryInfo === 'function') updateDeliveryInfo(pin);
    if (typeof showNearestStore === 'function') showNearestStore(pin, false);
  }

  /* ── SHOW CUSTOM POPUP (iOS) ── */
  function showPopup() {
    injectStyles();
    const overlay = createPopup();
    document.body.appendChild(overlay);

    document.getElementById('kf-geo-allow-btn')?.addEventListener('click', handleAllow);
    document.getElementById('kf-geo-once-btn')?.addEventListener('click', handleAllow);
    document.getElementById('kf-geo-deny-btn')?.addEventListener('click', handleDeny);
    document.getElementById('kf-geo-close-btn')?.addEventListener('click', handleDeny);
    overlay.addEventListener('click', e => { if (e.target === overlay) handleDeny(); });
  }

  /* ── ANDROID: DIRECT GEOLOCATION ── */
  function requestDirectLocation() {
    localStorage.setItem(GEO_ASKED_KEY, 'asked');

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        const pin = await getPincodeFromCoords(latitude, longitude);
        
        if (pin) {
          // Android pe bhi confirmation dikhao
          injectStyles();
          const overlay = document.createElement('div');
          overlay.id = 'kf-geo-overlay';
          document.body.appendChild(overlay);
          const popup = document.createElement('div');
          popup.id = 'kf-geo-popup';
          overlay.appendChild(popup);
          showPincodeConfirmation(pin);
        } else {
          localStorage.setItem(GEO_ASKED_KEY, 'allowed');
          console.warn('[KF Geo] ⚠️ Pincode nahi mila');
        }
      },
      (err) => {
        localStorage.setItem(GEO_ASKED_KEY, 'denied');
        console.warn('[KF Geo] Denied:', err.message);
      },
      { timeout: 10000, maximumAge: 300000 }
    );
  }

  /* ── MAIN INIT ── */
  function init() {
    if (window.innerWidth >= 750) return; // Desktop skip
    if (!isGuest()) return; // Logged-in user skip
    if (hasPin()) return; // Pin already set skip
    if (alreadyAsked()) return; // Already asked skip
    if (!navigator.geolocation) return; // No geolocation support skip


    // ✅ Block on specific page
    const blockedPages = [
    '/pages/rhea-kapoor-no-header'
    ];

    if (blockedPages.includes(window.location.pathname)) return;

    setTimeout(() => {
      if (isIOS()) {
        showPopup(); // iOS → custom popup → button tap → browser native
      } else {
        requestDirectLocation(); // Android → direct browser native popup
      }
    }, GEO_DELAY_MS);
    

    setTimeout(() => {
      if (isIOS()) {
        showPopup(); // iOS → custom popup → button tap → browser native
      } else {
        requestDirectLocation(); // Android → direct browser native popup
      }
    }, GEO_DELAY_MS);
  }

  /* ── BOOT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();